import {useQuery} from '@tanstack/react-query'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {doCustomAPICall} from '../utils/custom-api-utils'

/**
 * Get Content Slots with useQuery
 */
export const useContentSlots = (slotId, context, type, categoryId) => {
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const customAPIFolderName = 'content-slots'
    const buildApiPath = (slotId, context, type, categoryId) => {
        const basePath =
            context === 'global' ? `${context}/${slotId}` : `${context}/${categoryId}/${slotId}`

        return type === 'html' ? `${basePath}/html?` : `${basePath}?`
    }

    const apiPath = buildApiPath(slotId, context, type, categoryId)

    return useQuery({
        queryKey: ['custom', 'content-slots', slotId],
        queryFn: () =>
            doCustomAPICall(getTokenWhenReady, {
                config,
                appOrigin,
                customAPIFolderName,
                apiPath
            }),
        enabled: !!slotId
    })
}
